<template>
  <svg class="icon-user" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.7 16.7">
    <circle class="cls-1" cx="7.35" cy="4.35" r="3.5" />
    <path class="cls-1" d="M7.35,9.85a6.27,6.27,0,0,0-6.5,6h13A6.27,6.27,0,0,0,7.35,9.85Z" />
  </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.icon-user {
  display: block;
  stroke: var(--theme-icon-user-color);
  fill: transparent;
  stroke-width: 1.7px;
  width: 100%;
  height: 100%;
}
</style>
